// extracted by mini-css-extract-plugin
export default {"scroolMenuColor":"AsideMenu_scroolMenuColor__Xf4Bh","leftMenu":"AsideMenu_leftMenu__-YmL2"};